<div class="main" *ngIf="!isLoading">
  <div class="main-content" [class.platform-large-text]="getTextSize()">

    <div *ngIf="!confirmationFlag">

      <h1 class="main-title">ふれあい体験実施報告</h1>

      <form [formGroup]="c701InputForm" class="report-form">
        <!-- 団体名 -->
        <div class="form-row">
          <label class="form-label"><span class="label-bold">団体名</span></label>
          <span class="required-placeholder"></span>
          <span>{{ detailTask?.organization_name }}</span>
        </div>
        <!-- マッチング先 -->
        <div class="form-row">
          <label class="form-label"><span class="label-bold">マッチング先</span></label>
          <span class="required-placeholder"></span>
          <span>{{ detailTask?.register_organization_name }}</span>
        </div>
        <div *ngIf="class_id === '1'">
          <!-- 参加生徒・人数 -->
          <div class="form-row">
            <label class="form-label"><span class="label-bold">参加生徒学年・人数</span></label>
            <span class="required">*必須</span>
            <div class="input-column">
              <input title="参加人数" pInputText formControlName="desired_people_number" class="form-input" placeholder="例：中学3年生〇人" />
              <app-validator-message [control]="c701InputForm.get('desired_people_number')">
              </app-validator-message>
            </div>
          </div>
          <!-- 実施場所（市町村） -->
          <div class="form-row">
            <label class="form-label"><span title="実施地域（市区町村）" class="label-bold">実施地域（市区町村）</span></label>
            <span class="required">*必須</span>
            <div class="input-column">
              <p-dropdown inputId="city" optionLabel="name" optionValue="value" class="select-city"
                formControlName="implementation_city" [options]="postalNoList" placeholder="○○市" [showClear]="false"
                [filter]="true"></p-dropdown>
              <app-validator-message [control]="c701InputForm.get('implementation_city')">
              </app-validator-message>
            </div>
          </div>
          <!-- 実施機関 -->
          <div class="form-row">
            <label class="form-label"><span class="label-bold">実施場所</span></label>
            <span class="required">*必須</span>
            <div class="input-column">
              <input title="実施場所" pInputText formControlName="implementation_location" class="form-input" placeholder="例：〇〇中学校体育館" />
              <app-validator-message [control]="c701InputForm.get('implementation_location')">
              </app-validator-message>
            </div>
          </div>
          <!-- 担当者 -->
          <div class="form-row">
            <label class="form-label"><span class="label-bold">実施日時</span></label>
            <span class="required">*必須</span>
            <div class="input-column">
              <input title="実施日時" pInputText formControlName="implementation_datetime" class="form-input"
                placeholder="例：〇年〇月○日○時～○時、△月△日△時～△時（2日間）" />
              <app-validator-message [control]="c701InputForm.get('implementation_datetime')">
              </app-validator-message>
            </div>
          </div>
        </div>
        <div *ngIf="class_id === '2'">
          <div class="form-row">
            <label class="form-label"><span class="label-bold">参加乳幼児の年齢・人数</span></label>
            <span class="required">※必須</span>
            <div class="input-column">
              <input title="参加乳幼児の年齢・人数" pInputText formControlName="desired_people_number" class="form-input" placeholder="例：2～3歳〇人" />
              <app-validator-message [control]="c701InputForm.get('desired_people_number')">
              </app-validator-message>
            </div>
          </div>
        </div>
        <!-- 実施日時 -->
        <div class="form-row align-top">
          <label class="form-label align-top-text"><span class="label-bold">感想</span></label>
          <span class="required align-required">*必須</span>
          <div class="input-column">
            <textarea title="感想" pInputTextarea formControlName="impression" class="form-input"
              [placeholder]="class_id === '2' ? '良かった点、乳幼児の様子等' : '良かった点、生徒の反応、生徒の声等'"></textarea>
            <app-validator-message [control]="c701InputForm.get('impression')">
            </app-validator-message>
          </div>
        </div>
        <!-- アンケートへの回答状況 -->
        <div class="form-section align-top">
          <div class="label-container">
            <label class="form-label">アンケートへの回答状況</label>
            <div class="form-note">
              ふれあい体験を実施されたら、マイページに掲載しているアンケートにご協力ください。
            </div>
          </div>
          <span class="required align-required">*必須</span>
          <div class="input-column">
            <span title="アンケートへの回答状況" class="radio-group">
              <p-radioButton label="回答済" value="1" formControlName="survey_answer_flg" aria-label="回答済"></p-radioButton>
              <p-radioButton label="未回答" value="0" formControlName="survey_answer_flg" aria-label="未回答"></p-radioButton>
            </span>
            <app-validator-message [control]="c701InputForm.get('survey_answer_flg')">
            </app-validator-message>
          </div>
        </div>

        <!-- 注意文 vàng, gạch dưới -->
        <div class="form-warning">
          ふれあい体験の取組を広げるため、マッチングシステム上での事例紹介にご協力ください。
        </div>

        <!-- 事例紹介への掲載可否 -->
        <div class="form-section align-top">
          <div class="label-container">
            <label class="form-label">事例紹介への掲載可否</label>
            <div class="form-note">
              ※「可」とした場合は、以下の情報も入力ください。掲載する場合は記載いただいた内容を編集する場合があります。
            </div>
          </div>
          <span class="required align-required">*必須</span>
          <div class="input-column">
            <span class="radio-group">
              <p-radioButton label="可" value="1" formControlName="publish_flg" aria-label="可"></p-radioButton>
              <p-radioButton label="不可" value="0" formControlName="publish_flg" aria-label="不可"></p-radioButton>
            </span>
            <app-validator-message [control]="c701InputForm.get('publish_flg')">
            </app-validator-message>
          </div>
        </div>

        <!-- 実施概要 -->
        <div class="form-section align-top">
          <label class="form-label align-top-text">実施概要</label>
          <span class="required-placeholder"></span>
          <div class="input-column">
            <textarea pInputTextarea class="form-input" formControlName="overview" placeholder="実施した内容等"></textarea>
            <app-validator-message [control]="c701InputForm.get('overview')">
            </app-validator-message>
          </div>
        </div>

        <!-- 工夫したこと -->
        <div class="form-section align-top">
          <label class="form-label align-top-text">工夫したこと</label>
          <span class="required-placeholder"></span>
          <div class="input-column">
            <textarea pInputTextarea class="form-input" formControlName="ingenuity"></textarea>
            <app-validator-message [control]="c701InputForm.get('ingenuity')">
            </app-validator-message>
          </div>
        </div>

        <!-- 得られた成果 -->
        <div class="form-section align-top">
          <label class="form-label align-top-text">得られた成果</label>
          <span class="required-placeholder"></span>
          <div class="input-column">
            <textarea pInputTextarea class="form-input" formControlName="results"></textarea>
            <app-validator-message [control]="c701InputForm.get('results')">
            </app-validator-message>
          </div>
        </div>

        <!-- 写真 -->
        <div class="form-section align-top">
          <div class="label-container">
            <label class="form-label align-top-text">写真</label>
            <div class="form-note">
              ※掲載する場合は、個人が特定できないよう加工します。
            </div>
          </div>
          <span class="required-placeholder"></span>
          <div class="p-fileupload-custom ui-fluid">
            <input title="写真" pInputText autocomplete="off"
              [formControlName]="image" type="hidden" />
            <p-fileUpload #fileUpload [customUpload]="true"
              [showUploadButton]="false" [showCancelButton]="false" [multiple]="false" class="btn-upload" (onSelect)="
                  uploadFile(
                    $event,
                    'image',
                    fileUpload
                  )
                ">
              <ng-template pTemplate="content">
                <div class="file-content">
                  <div class="file_name">{{ fileName }}</div>
                  <div>
                    <i class="pi pi-times" *ngIf="fileUploadedImage"
                      (click)="removeFile(fileUploadedImage, fileUpload, 'image')"></i>
                  </div>
                </div>
              </ng-template>
            </p-fileUpload>
          </div>
        </div>
        <div class="form-section center">
          <button pButton type="button" label="確認画面へ" class="btn-register" [disabled]="!c701InputForm.valid"
            (click)="moveC702()"></button>
        </div>
      </form>

    </div>
    <div *ngIf="confirmationFlag">
      <h1 class="main-title">ふれあい体験実施報告（確認）</h1>
      <form class="report-form">
        <!-- 団体名 -->
        <div class="form-row">
          <label class="form-label"><span class="label-bold">団体名</span></label>
          <span class="required-placeholder"></span>
          <span>{{ detailTask?.organization_name }}</span>
        </div>
        <!-- マッチング先 -->
        <div class="form-row">
          <label class="form-label"><span class="label-bold">マッチング先</span></label>
          <span class="required-placeholder"></span>
          <span>{{ detailTask?.register_organization_name }}</span>
        </div>
        <div *ngIf="class_id === '1'">
          <!-- 参加乳幼児の年齢・人数 -->
          <div class="form-row">
            <label class="form-label"><span class="label-bold">参加生徒学年・人数</span></label>
            <span class="required">*必須</span>
            <span>{{ c701InputForm.value.desired_people_number }}</span>
          </div>
          <!-- 実施地域(市町村) -->
          <div class="form-row">
            <label class="form-label"><span class="label-bold">実施地域（市区町村）</span></label>
            <span class="required">*必須</span>
            <span> {{ getNameByValue(this.postalNoList, c701InputForm.value.implementation_city) }}</span>

          </div>
          <!-- 実施場所 -->
          <div class="form-row">
            <label class="form-label"><span class="label-bold">実施場所</span></label>
            <span class="required">*必須</span>
            <span>{{ c701InputForm.value.implementation_location }}</span>
          </div>
          <!-- 実施日時 -->
          <div class="form-row">
            <label class="form-label"><span class="label-bold">実施日時</span></label>
            <span class="required">*必須</span>
            <span>{{ c701InputForm.value.implementation_datetime }}</span>
          </div>
        </div>
        <div *ngIf="class_id === '2'">
          <div class="form-row">
            <label class="form-label"><span class="label-bold">参加乳幼児の年齢・人数</span></label>
            <span class="required">*必須</span>
            <span>{{ c701InputForm.value.desired_people_number }}</span>
          </div>
        </div>
        <!-- 感想 -->
        <div class="form-row align-top">
          <label class="form-label align-top-text"><span class="label-bold">感想</span></label>
          <span class="required align-required">*必須</span>
          <span>{{ c701InputForm.value.impression }}</span>
        </div>
        <!-- アンケートへの回答状況 -->
        <div class="form-section align-top">
          <div class="label-container">
            <label class="form-label">アンケートへの回答状況</label>
            <div class="form-note">
              ふれあい体験を実施されたら、マイページに掲載しているアンケートにご協力ください。
            </div>
          </div>
          <span class="required">*必須</span>
          <span>
            {{
            c701InputForm.value.survey_answer_flg === '1'
            ? '回答済'
            : (c701InputForm.value.survey_answer_flg === '0' ? '未回答' : '')
            }}
          </span>
        </div>

        <!-- 注意文 vàng, gạch dưới -->
        <div class="form-warning">
          ふれあい体験の取組を広げるため、マッチングシステム上での事例紹介にご協力ください。
        </div>

        <!-- 事例紹介への掲載可否 -->
        <div class="form-section align-top">
          <div class="label-container">
            <label class="form-label">事例紹介への掲載可否</label>
            <div class="form-note">
              ※「可」とした場合は、以下の情報も入力ください。掲載する場合は記載いただいた内容を編集する場合があります。
            </div>
          </div>
          <span class="required">*必須</span>
          <span>
            {{
            c701InputForm.value.publish_flg === '1'
            ? '可'
            : (c701InputForm.value.publish_flg === '0' ? '不可' : '')
            }}
          </span>
        </div>
        <!-- 実施概要 -->
        <div class="form-section">
          <label class="form-label">実施概要</label>
          <span class="required-placeholder"></span>
          <span>{{ c701InputForm.value.overview }}</span>
        </div>
        <!-- 工夫したこと -->
        <div class="form-section">
          <label class="form-label">工夫したこと</label>
          <span class="required-placeholder"></span>
          <span>{{ c701InputForm.value.ingenuity }}</span>
        </div>
        <!-- 得られた成果 -->
        <div class="form-section">
          <label class="form-label">得られた成果</label>
          <span class="required-placeholder"></span>
          <span>{{ c701InputForm.value.results }}</span>
        </div>
        <!-- 写真 -->
        <div class="form-section align-top">
          <div class="label-container">
            <label class="form-label">写真</label>
            <div class="form-note">
              ※掲載する場合は、個人が特定できないよう加工します。
            </div>
          </div>
          <span class="required-placeholder"></span>
          <span>{{ fileName }}</span>
        </div>
        <div class="form-content register p-col-12">
          <div class="p-grid p-grid-register center">
            <button pButton type="button" label="登録する" class="btn-register" (click)="moveC703()"></button>
            <button pButton type="button" label="入力画面へ戻る" class="button2 btn-register btn-delete"
              (click)="moveC701()"></button>
          </div>
        </div>
      </form>
    </div>
  </div>
</div>
<p-toast position="top-center"></p-toast>